module.exports = __webpack_public_path__ + "img/table-right.111f707c.svg";